import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MenuComponent} from './menu/menu.component';
import {IonicModule} from '@ionic/angular';
import {HeaderComponent} from './header/header.component';
import {FooterComponent} from './footer/footer.component';
import {RouterModule} from '@angular/router';
import {DropdownComponent} from './dropdown/dropdown.component';
import {RadioGroupComponent} from './radio-group/radio-group.component';
import {TranslateModule} from '@ngx-translate/core';
import {SkeletonTasksComponent} from './skeleton/tasks/skeleton-tasks.component';
import {SkeletonListComponent} from './skeleton/list/skeleton-list.component';
import {InlineSvgComponent} from './inline-svg/inline-svg.component';
import {InlineIconSvgComponent} from './inline-icon-svg/inline-icon-svg.component';
import {ManagerPanelComponent} from './manager-panel/manager-panel.component';
import {FormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {DatepickerComponent} from './datepicker/datepicker.component';
import {ReadonlyComponent} from './readonly/readonly.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        IonicModule,
        FormsModule,
        NgSelectModule,
        TranslateModule.forChild()
    ],
    declarations: [
        MenuComponent,
        HeaderComponent,
        FooterComponent,
        DropdownComponent,
        InlineSvgComponent,
        InlineIconSvgComponent,
        RadioGroupComponent,
        SkeletonTasksComponent,
        SkeletonListComponent,
        ManagerPanelComponent,
        DatepickerComponent,
        ReadonlyComponent
    ],
    exports: [
        MenuComponent,
        HeaderComponent,
        FooterComponent,
        DropdownComponent,
        InlineSvgComponent,
        InlineIconSvgComponent,
        RadioGroupComponent,
        SkeletonTasksComponent,
        SkeletonListComponent,
        ManagerPanelComponent,
        DatepickerComponent,
        ReadonlyComponent
    ]
})
export class ComponentsModule {
}
